import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ProductImage } from "./ProductImage";

export const ProductCard = ({ product, index = 0, size = "default" }) => {
  const aspect = size === "tall" ? "aspect-[3/4]" : "aspect-square";
  const compact = size === "compact";
  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.65, delay: Math.min(index * 0.035, 0.5), ease: [0.16, 1, 0.3, 1] }}
      className="group"
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/produit/${product.slug}`} className="block">
        <div className={`product-frame ${aspect} relative overflow-hidden transition-all duration-700 ease-out group-hover:-translate-y-2 group-hover:shadow-[0_30px_80px_-20px_rgba(255,195,0,0.45),0_0_0_1px_rgba(255,195,0,0.2)]`}>
          <ProductImage
            path={product.image}
            alt={product.name}
            loading="lazy"
            decoding="async"
            className={`absolute inset-0 w-full h-full object-contain ${compact ? "p-4 md:p-6" : "p-6 md:p-10"} transition-transform duration-1000 ease-out group-hover:scale-[1.08]`}
          />
          {product.brand && (
            <span className="absolute top-3 left-3 tag-label bg-black text-white/90 px-2 py-1 !text-[10px] transition-colors duration-500 group-hover:bg-[#FFC300] group-hover:text-black">
              {product.brand}
            </span>
          )}
          <span className="absolute top-3 right-3 w-9 h-9 bg-[#FFC300] flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-400 shadow-[0_8px_24px_rgba(255,195,0,0.5)]">
            <ArrowUpRight size={16} className="text-black" />
          </span>
        </div>
        <div className={`${compact ? "mt-2.5" : "mt-4 space-y-1.5"} transition-transform duration-500 ease-out group-hover:translate-x-1`}>
          {!compact && (
            <p className="font-body text-[10px] text-zinc-500 uppercase tracking-[0.2em]">
              {product.category_label}
            </p>
          )}
          <h3 className={`font-display ${compact ? "text-[13px] md:text-sm" : "text-base md:text-lg"} uppercase tracking-tight leading-snug group-hover:text-[#FFC300] transition-colors duration-500`}>
            {product.name}
          </h3>
          {!compact && product.hook && (
            <p className="font-body text-xs text-zinc-400 leading-snug line-clamp-1">{product.hook}</p>
          )}
        </div>
      </Link>
    </motion.article>
  );
};
